import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Project from './Project'
import withWorks from '../hoc/withWorks'
import workProp from '../workProp'

class MobileWorks extends Component {
  state = {
    activeIndex: 0,
    isPlaying: false,
  }

  handleTogglePlay = index => (shouldPlay, isActive) => {
    if (shouldPlay) {
      this.setState({
        activeIndex: index,
        isPlaying: true,
      })
      return
    }

    if (isActive) {
      this.setState({
        isPlaying: false,
      })
    }
  }

  render() {
    const { width, works } = this.props

    return (
      <div id="works">
        {works.map((work, index) => (
          <Project
            key={work.slug}
            director={work.director}
            poster={work.images[0].thumbs[1].name}
            slug={work.slug}
            title={work.title}
            videoRatio={work.videoRatio}
            videoUrl={work.videoUrl}
            width={width}
            onTogglePlay={this.handleTogglePlay(index)}
            isActive={index === this.state.activeIndex}
            isPlaying={this.state.isPlaying}
          />
        ))}
      </div>
    )
  }
}

MobileWorks.propTypes = {
  width: PropTypes.number.isRequired,
  // eslint-disable-next-line
  works: workProp.isRequired,
}

export default withWorks(MobileWorks)



// WEBPACK FOOTER //
// ./src/components/MobileWorks.js